'use client';

import { useAuthMutations } from '@/modules/authentication/contracts';

import { useAuthStore } from '../stores/auth.store';

export const useLogout = () => {
	const { clearAuth } = useAuthStore();
	const { logoutMutation } = useAuthMutations();

	const execute = async () => {
		try {
			await logoutMutation.mutateAsync();
			clearAuth();
		}
		catch (error) {
			console.log('Logout error:', error);
		}
	};

	return {
		execute,
		...logoutMutation,
	};
};
